import { useHasPermission } from '@app/core/auth/authorization/hooks/useHasPermission';
import { isOwnedStation } from '@app/core/stations/helpers';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { useIsExternalExportEnabled } from './isExternalExportEnabled';
import { Station } from '@app/core/types/stations';

/**
 * Whether the current user may use external export for this station
 * (owned station + feature enabled + Fragments_Delivery permission).
 */
export function useAllowFragmentExternalExport(station: Station | undefined) {
  const hasPermission = useHasPermission(fragmentsPermissions.Fragments_Delivery);
  const allowExternalExport = useIsExternalExportEnabled(station);

  return Boolean(station && isOwnedStation(station) && allowExternalExport && hasPermission);
}
